/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateResourceType {
    getFixupPrototypeFunction() { return TemplateResourceType.fixupPrototype; }

    static newInstance(model: Partial<TemplateResourceType>): TemplateResourceType {
        let obj = Object.assign(new TemplateResourceType(), model);
        TemplateResourceType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateResourceType>): TemplateResourceType {
        if (!model) return null;
        return TemplateResourceType.newInstance(<TemplateResourceType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateResourceType) {
        if (!obj) return;

        models.TemplateResourceType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateResourceType): boolean {
        Object.setPrototypeOf(obj, TemplateResourceType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud provider these resource types belong to, e.g. 'AWS'
     */
    cloud: models.ProviderName;

    /**
     * Resource types for this service, e.g. ['EC2']
     */
    resource_types: Array<string>;

}
